import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { motion } from "framer-motion";
import { ReactSVG } from "react-svg";
import BackgroundVideo from "../components/Background-Video";
import Videos from "../video/101160_SCS_Interactive_Sc11_4K_10s_V2.mp4";

const IntegratedSolution = () => {
  const [activeDot, setActiveDot] = useState("");
  const [dotOneX, setDotOneX] = useState();
  const [dotOneY, setDotOneY] = useState();
  const [blobOneX, setBlobOneX] = useState();
  const [blobOneY, setBlobOneY] = useState();
  const [dotTwoX, setDotTwoX] = useState();
  const [dotTwoY, setDotTwoY] = useState();
  const [blobTwoX, setBlobTwoX] = useState();
  const [blobTwoY, setBlobTwoY] = useState();
  const [dotThreeX, setDotThreeX] = useState();
  const [dotThreeY, setDotThreeY] = useState();
  const [blobThreeX, setBlobThreeX] = useState();
  const [blobThreeY, setBlobThreeY] = useState();
  const [dotFourX, setDotFourX] = useState();
  const [dotFourY, setDotFourY] = useState();
  const [blobFourX, setBlobFourX] = useState();
  const [blobFourY, setBlobFourY] = useState();

  const getPosition = () => {
    const dotOne = document.getElementById("dotOne").getBoundingClientRect();
    const dotOneTop = dotOne.top;
    const dotOneLeft = dotOne.left;

    setDotOneX(dotOneLeft + 21.5);
    setDotOneY(dotOneTop + 21.5);

    const blobOne = document.getElementById("blobOne").getBoundingClientRect();
    const blobOneTop = blobOne.top;
    const blobOneLeft = blobOne.left;

    setBlobOneX(blobOneLeft);
    setBlobOneY(blobOneTop);

    const dotTwo = document.getElementById("dotTwo").getBoundingClientRect();
    const dotTwoTop = dotTwo.top;
    const dotTwoLeft = dotTwo.left;

    setDotTwoX(dotTwoLeft + 21.5);
    setDotTwoY(dotTwoTop + 21.5);

    const blobTwo = document.getElementById("blobTwo").getBoundingClientRect();
    const blobTwoTop = blobTwo.top;
    const blobTwoLeft = blobTwo.left;

    setBlobTwoX(blobTwoLeft);
    setBlobTwoY(blobTwoTop);

    const dotThree = document
        .getElementById("dotThree")
        .getBoundingClientRect();
    const dotThreeTop = dotThree.top;
    const dotThreeLeft = dotThree.left;

    setDotThreeX(dotThreeLeft + 21.5);
    setDotThreeY(dotThreeTop + 21.5);

    const blobThree = document
        .getElementById("blobThree")
        .getBoundingClientRect();
    const blobThreeTop = blobThree.top;
    const blobThreeLeft = blobThree.left;

    setBlobThreeX(blobThreeLeft);
    setBlobThreeY(blobThreeTop);

    const dotFour = document.getElementById("dotFour").getBoundingClientRect();
    const dotFourTop = dotFour.top;
    const dotFourLeft = dotFour.left;

    setDotFourX(dotFourLeft + 21.5);
    setDotFourY(dotFourTop + 21.5);

    const blobFour = document
        .getElementById("blobFour")
        .getBoundingClientRect();
    const blobFourTop = blobFour.top;
    const blobFourLeft = blobFour.left;

    setBlobFourX(blobFourLeft);
    setBlobFourY(blobFourTop);
  };

  useEffect(() => {
    getPosition();
  }, []);

  return (
      <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative top-[120px] 2xl:top-[172px] left-0"
      >
        <BackgroundVideo fullscreen video={Videos} />
        <div className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative ">
          <div className=" bg-opacity-50 backdrop-blur-md bg-white w-[500px] 2xl:w-[900px] py-7 px-9 2xl:py-14 2xl:px-[59px] rounded-3xl relative left-10 top-24 zoom-8">
            <h1 className="font-semibold uppercase text-dell-blue font-proxima-nova text-lg 2xl:text-[25px] 2xl:leading-[30px] pb-3">
              Mining Operation
            </h1>
            <p className=" text-[#444444] text-xl 2xl:text-[30px] 2xl:leading-[37px] font-proxima-nova font-thin">
              By co-creating with Dell, you deliver
              positive outcomes for customers and benefit by monetizing your 5G
              investment, growing managed services business, adding users to your
              network and gaining access to edge and enterprise data center spend.
            </p>
          </div>
          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 1 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotOneX}
                y1={dotOneY}
                x2={blobOneX}
                y2={blobOneY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 2 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotTwoX}
                y1={dotTwoY}
                x2={blobTwoX}
                y2={blobTwoY}
                stroke="#444444"
                strokeDasharray="15 15"
                strokeDashoffset="15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 3 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotThreeX}
                y1={dotThreeY}
                x2={blobThreeX}
                y2={blobThreeY}
                stroke="#444444"
                strokeDasharray="15 15"
                strokeDashoffset="15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 4 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <motion.line
                x1={dotFourX}
                y1={dotFourY}
                x2={blobFourX}
                y2={blobFourY}
                stroke="#444444"
                strokeDasharray="15 15"
                strokeDashoffset="15"
            />
          </svg>
          <div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
            <div></div>
            <div className="relative flex justify-center items-start"></div>
            <div className="relative">
              <div
                  id="dotOne"
                  onMouseEnter={() => setActiveDot(1)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(1)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
                  className="dot border-w cursor-pointer absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-8 right-[55%] bg-[#444444] border-2"
              ></div>
            </div>
            <div className="relative flex "></div>
            <div className="relative flex justify-center">
              <div
                  id="dotTwo"
                  onMouseEnter={() => setActiveDot(2)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(2)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
                  className="dot border-w cursor-pointer absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-9 left-16 2xl:left-auto 2xl:top-[20%] bg-[#444444] border-2"
              ></div>
            </div>

            <div className="relative flex justify-center"></div>
            <div className="relative flex justify-center items-start"></div>
            <div className="relative flex justify-end">
              <div
                  id="dotThree"
                  onMouseEnter={() => setActiveDot(3)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(3)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
                  className="dot border-w cursor-pointer absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-[85%] 2xl:top-2/3 right-28 2xl:right-48 bg-[#444444] border-2"
              ></div>
            </div>
            <div className="relative">
              <div
                  id="blobOne"
                  className={classnames(
                      "absolute left-0 bottom-0 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[443px] h-[443px] transition-all duration-300 ",
                      activeDot === 1
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <ReactSVG
                    src="../images/integrated-icons/private.svg"
                    className=" mb-2"
                />
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Private Wireless:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  A private cellular network <br />
                  enables the adoption of <br />
                  autonomous remote operations <br />
                  of drones, haulers, load and <br />
                  dump vehicles and drill rigs, <br />
                  helping to improve efficiency <br />
                  and keeping workers from harm.
                </p>
              </div>
              <div
                  id="blobTwo"
                  className={classnames(
                      "absolute  left-0 top-0 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white min-w-[443px] h-[443px] transition-all duration-300 ",
                      activeDot === 2
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <ReactSVG
                    src="../images/integrated-icons/cyber.svg"
                    className=" mb-2"
                />
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Cyber Recovery:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Help protect critical data such as <br />
                  geological exploration research, <br />
                  location details and proprietary <br />
                  extraction/processing
                  <br />
                  technologies by securing it in the <br />
                  cyber vault with a communication <br />
                  service provider.
                </p>
              </div>
              <div
                  id="blobThree"
                  className={classnames(
                      "absolute left-0 bottom-0 px-10 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white w-[377px] h-[377px] transition-all duration-300 ",
                      activeDot === 3
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <ReactSVG
                    src="../images/integrated-icons/connected.svg"
                    className=" mb-2"
                />
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Connected Laptop:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Workers, using ruggedized <br />
                  cellular laptops, can access <br />
                  data and collaborate with team <br />
                  members in real-time to make
                  <br />
                  better-informed decisions.
                </p>
              </div>
              <div
                  id="blobFour"
                  className={classnames(
                      "absolute left-0 bottom-0 px-8 text-center flex flex-col justify-center items-center rounded-full bg-[#444444] text-white w-[401px] h-[401px] transition-all duration-300",
                      activeDot === 4
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <ReactSVG
                    src="../images/integrated-icons/edge.svg"
                    className=" mb-2"
                    alt={"icon"}
                />
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Edge Compute:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Surveillance cameras and <br />
                  sensors stream video and <br />
                  metrics back to a MEC (multi-
                  <br />
                  access edge computing) to <br />
                  analyze and look for potential <br />
                  proactive maintenance <br />
                  needed on equipment to help
                  <br />
                  reduce downtime.
                </p>
              </div>
            </div>
            <div></div>

            <div></div>
            <div className="relative flex justify-center"></div>
            <div className="relative">
              <div
                  id="dotFour"
                  onMouseEnter={() => setActiveDot(4)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(4)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
                  className="dot border-w cursor-pointer absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-[73%] 2xl:top-[50%] right-[50%] bg-[#444444] border-2"
              ></div>
            </div>
            <div></div>
            <div></div>
          </div>
        </div>
      </motion.div>
  );
};

export default IntegratedSolution;
